module.exports = __webpack_public_path__ + "img/tip-box.d4a2b65f.png";